export type FontStyle = {
  fontSize: number
  lineHeight: number
  fontWeight: number
  letterSpacing?: string
}

const ROOT_FONT_SIZE = 16

export const pxToRem = (px: number) => `${px / ROOT_FONT_SIZE}rem`

/** Text follows the browser's font size setting: the size in rem and the line height unitless. */
export const typeStyle = ({ fontSize, lineHeight, fontWeight, letterSpacing }: FontStyle) => ({
  fontSize: pxToRem(fontSize),
  lineHeight: lineHeight / fontSize,
  fontWeight,
  ...(letterSpacing && { letterSpacing })
})
